import { render, staticRenderFns } from "./RealTimep.vue?vue&type=template&id=c6101848&scoped=true"
import script from "./RealTimep.vue?vue&type=script&lang=js"
export * from "./RealTimep.vue?vue&type=script&lang=js"
import style0 from "./RealTimep.vue?vue&type=style&index=0&id=c6101848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6101848",
  null
  
)

export default component.exports